import { onUnmounted } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { gtagTrackEvent } from "@/lib/analytics";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { EVENTS } from "@/const";

export default function useEmailVerification() {
  const { authUser, allowAccess, setVerificationStatus } = useAuthUser();

  const setUserVerificationStatus = async (status: boolean) => {
    if (!status) {
      emitter.emit(EVENTS.STATUS_SHOW, { text: $t("Invalid verification code") });
      return;
    }

    await setVerificationStatus(status);

    gtagTrackEvent("Sign up", {
      event_category: "SignUpBtn",
      event_action: "signUpSubmit",
    });
  };

  let timeout: ReturnType<typeof setTimeout>;
  const stopPeriodicalConfirmationCheck = () => timeout && clearTimeout(timeout);
  const startPeriodicalConfirmationCheck = (onSuccess: Function = () => {}) => {
    timeout = setTimeout(async () => {
      if (!authUser.value || allowAccess.value) {
        return;
      }
      const userId = authUser.value.id;
      const status = await providers.EmailVerificationProvider.find({ userId: [userId] });

      if (status[userId]) {
        await setUserVerificationStatus(status[userId]);
        onSuccess();
      } else {
        startPeriodicalConfirmationCheck(onSuccess);
      }
    }, 5000);
  };
  onUnmounted(() => stopPeriodicalConfirmationCheck());

  return {
    startPeriodicalConfirmationCheck,
    stopPeriodicalConfirmationCheck,
    setUserVerificationStatus,
  };
}
